import { useLocation } from 'react-router-dom'
import { Category } from 'lib/types'
import { getUrlPath } from 'lib/core/resources/helpers'
import { useCategoryList } from '../useCategoryList'

export interface CategoryMetaData {
  description?: string
  title?: string
  keywords?: string
}

interface CategoryData {
  category?: Category
  meta?: CategoryMetaData
}

export const useCategoryByPath = (): CategoryData => {
  const location = useLocation()
  const urlPath = getUrlPath(location)
  const categoryList = useCategoryList()
  const category = categoryList.urlPath[urlPath]

  if (!category) {
    return {
      category: undefined,
      meta: undefined
    }
  }

  const categoryMetaData = {
    description: category?.attr.meta_description,
    title: category?.attr.meta_title,
    keywords: category?.attr.meta_keywords
  }

  return {
    category,
    meta: categoryMetaData
  }
}
